/**
 * Utilitário para exportação de dados em CSV e JSON
 */

export function exportToCSV<T extends Record<string, unknown>>(
  data: T[],
  filename: string,
  columns?: { key: keyof T; label: string }[]
): void {
  if (data.length === 0) {
    alert('Nenhum dado para exportar');
    return;
  }

  const cols =
    columns ||
    (Object.keys(data[0]) as (keyof T)[]).map((key) => ({
      key,
      label: String(key),
    }));

  const header = cols.map((c) => c.label).join(',');

  const rows = data.map((item) =>
    cols
      .map((c) => {
        const value = item[c.key];
        const str = String(value ?? '').replace(/"/g, '""');
        return str.includes(',') || str.includes('\n') ? `"${str}"` : str;
      })
      .join(',')
  );

  const csv = [header, ...rows].join('\n');

  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}_${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function exportToJSON<T>(data: T[], filename: string): void {
  if (data.length === 0) {
    alert('Nenhum dado para exportar');
    return;
  }
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}_${new Date().toISOString().split('T')[0]}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
